var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('back-to-top',{attrs:{"bottom":"50px","right":"50px","visibleoffset":"200"}},[_c('button',{staticClass:"btn back-to-top primary-button"},[_c('i',{staticClass:"fa fa-arrow-up"})])])}
var staticRenderFns = []

export { render, staticRenderFns }